<script>
import RappiPayModal from '@components/modals/rappipay-modal'

export default {
  name: 'TransactionRow',
  props: {
    transaction: {
      type: Object,
      required: true,
    },
  },
  computed: {
    computedSize () {
      return this.isRappiPay ? 4 : 2
    },
    isRappiPay () {
      return this.transaction.gateway_type === 'RappiPay'
    },
    isPreAuthorization () {
      const text = this.transaction.text.toLowerCase()
      return text.includes('pre') || text.includes('pré')
    },
    computedAmountStyles () {
      return {
        color: this.transaction.amountColor,
        'font-weight': this.transaction.amountBold ? 'bold' : 'normal',
        'text-decoration': this.isPreAuthorization ? 'line-through' : 'none',
      }
    }
  },
  created () {
    this.imageValidation()
  },
  methods: {
    showRappiPayModal () {
      this.$modal.show(
        RappiPayModal,
        {
          copies: {
            modalTitle: this.transaction.modal_title,
            modalMessage: this.transaction.modal_message,
          },
        },
        {
          height: 'auto',
          width: '80%',
        },
        {
          'before-close': event => { },
        }
      )
    },
    imageValidation () {
      if (
        this.transaction.logo ===
        'https://img.rappi.com/support/payments/master.png'
      )
        this.transaction.logo =
          'https://img.rappi.com/support/payments/mastercard.png'
      if (this.transaction.logo.includes('null'))
        this.transaction.logo = this.getDefaultImg()
    },
    imageFallback () {
      this.transaction.logo = this.getDefaultImg()
    },
    getDefaultImg: function () {
      var image = require.context('@assets/images/', false, /\.png$/)
      return image('./payment.png')
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <v-layout :class="$style.container__transaction">
      <img
        :class="$style.container__transaction__logo"
        :src="transaction.logo"
        @error="imageFallback()"
      >
      <div :class="$style.container__transaction__info">
        <p :class="$style.container__transaction__info__date">
          {{ transaction.created_at }}
        </p>
        <p
          :class="$style.container__transaction__info__description"
          :style="{ color: transaction.descriptionColor }"
        >
          {{ transaction.description }}
        </p>
        <p 
          v-if="transaction.text" 
          :class="$style.container__transaction__info__text">
          {{ transaction.text }}
        </p>
      </div>
      <v-flex :class="$style.container__transaction__amount">
        <p :style="computedAmountStyles">{{ transaction.amount }}</p>
      </v-flex>
    </v-layout>
  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: flex-start;
  padding: .2rem 1rem;

  &__transaction {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    padding: 1.5rem 0;
    border-bottom: 1px solid $divider-gray;


    &__info {
      display: flex;
      flex-flow: column wrap;
      align-items: flex-start;
      justify-content: center;
      max-width: 100%;
      height: 100%;
      margin-left: .1rem;


      &__date {
        @extend %typography-small;

        color: $color-button-disabled-bg-gradient;
        font-weight: 600;
        margin-top: 10rem;
      }

      &__description {

        margin-top: .1rem;
        font-weight: 600;
        font-size: 1rem;
        span {
          text-transform: capitalize;
        }
      }

      &__text {
        @extend %typography-small;
        display: block;
        border: 1px solid $orange-alert;
        border-radius: 22px;
        margin-top: .5rem !important;
        padding: 2px 6px !important;
        color: $orange-alert;
      }
    }

    &__logo {
      margin-right: 0.8rem;
      width: 3.5rem;
      height: 3.5rem;
      border-radius: 50%;
    }

    &__amount {
      @extend %typography-small;

      display: flex;
      flex-flow: row wrap;
      align-items: flex-end;
      justify-content: flex-end;
      text-align: right;
      float: right;
      margin-top: -1rem;
    }
  }

  p {
    padding: 0;
    margin: 0;
  }
}
</style>
